import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/utilaje-de-constructii-si-agricole/")({
  head: () => routeHead("/utilaje-de-constructii-si-agricole/"),
  beforeLoad: () => {
    throw redirect({ href: "/utilaje", statusCode: 301, replace: true });
  },
});
